import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./set-sample-request-shipping-data-modal.html";

// import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import sampleRequestManager from "../../controllers/sampleRequestManager";
// import ClientFollowUp from "../../_shark_models/ClientFollowUp";

class SetSampleRequestShippingDataModalComponent extends Component {
	constructor () {
		super("setSampleRequestShippingDataModalComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			this.open();
		}
	}

	close () {
		Shark.set({
			currNotComplianceReport: null
		});

		this.set({
			open: false,
		});
		$(`#setSampleRequestShippingDataModal`).modal("hide");
	}
	
	init () {
		this.addComponents([informationModalComponent, waitBoxComponent]);
	}

	open () {
		$(`#setSampleRequestShippingDataModal`).modal("show");
		this.set({
			open: true,
		});
	}
	setSampleRequestShippingData (sampleRequest) {
		console.log(sampleRequest);
		Shark.set({
			currSampleRequest: sampleRequest
		});
		Shark.render();
		this.open();
	}

	setSampleRequestShippingDataBtn_clickHandler (event, data) {
		const { sampleRequestList } = Shark.get();
		const currSampleRequest = Utils.safp(sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			this.setSampleRequestShippingData(currSampleRequest);
		}
	}

	setSampleRequestShippingDataModalCancelBtn_clickHandler () {
		const { currSampleRequest } = Shark.get();
		
		if (currSampleRequest) {
			currSampleRequest.restore();
		}

		this.close();
	}

	setSampleRequestShippingDataModalConfirmBtn_clickHandler () {
		const { currSampleRequest } = Shark.get();
		
		if (currSampleRequest) {
			waitBoxComponent.open();

			sampleRequestManager.setShippingData(currSampleRequest)
			.then(() => {
				// console.log({response});

				// const newFollowUp = new ClientFollowUp({
				// 	body: `APP Impostati i dettagli di spedizione per la Richiesta di Campionatura <strong>${currSampleRequest.__requestTypeLabel}</strong>. Codice di Tracking: <q>${currSampleRequest.shippingData.trackingCode}</q>, costo: <q>${currSampleRequest.__shippingCostLabel}</q>`,
				// 	clientGuid: currSampleRequest.contactGuid,
				// 	referenceGuid: currSampleRequest.guid,
				// 	referenceType: "sampleRequest",
				// 	status: 3,
				// 	type: "system"
				// });

				// followUpManager.save(newFollowUp)
				// .then(() => {
				this.close();
				waitBoxComponent.close();

				if (Shark.activePage.refreshList) {
					Shark.activePage.refreshList();
				}
				else {
					Shark.render();
				}
				// });
			});
		}
	}
}

const setSampleRequestShippingDataModalComponent = new SetSampleRequestShippingDataModalComponent();

Shark.registerComponent(setSampleRequestShippingDataModalComponent);

export default setSampleRequestShippingDataModalComponent;
